const modules = async () => {
  const response = await fetch('https://apigw.olx.com.br/v4/me', {
    'headers': {
      'x-olx-team-key': '5XzjuCgmYE7qMlYpsLZbTvm98ik4CS4a'
    },
    'referrerPolicy': 'strict-origin-when-cross-origin',
    'mode': 'cors',
    'credentials': 'include'
  })

  if (response.status >= 400) {
    return Promise.reject(response)
  }

  return response.json()
}

export default modules
